import { css } from '@emotion/react'

export const chart = css`
  position: relative;
`
